import type { TOC } from '@ember/component/template-only';
import type { BetaStat } from 'tio-employee/utils/beta/home-model';

/**
 * One KPI tile in the active-user hero.
 *
 * Design: label 14/500 on --body, value 24/600 on --tx, footnote 14/500 on
 * --tx3 with a trailing 16px glyph.
 */
const BetaHomeStatCard: TOC<{
  Args: { stat: BetaStat };
  Element: HTMLDivElement;
}> = <template>
  <div class="tio-beta-home__stat" data-test-beta-stat={{@stat.id}} ...attributes>
    <div class="tio-col">
      <div class="tio-beta-home__stat-label">{{@stat.label}}</div>
      <div class="tio-beta-home__stat-value">{{@stat.value}}</div>
    </div>

    <div class="tio-beta-home__meta">
      <span>{{@stat.meta}}</span>
      {{#let @stat.icon as |Icon|}}
        <Icon @size={{16}} />
      {{/let}}
    </div>
  </div>
</template>;

export default BetaHomeStatCard;
